// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__37Aic","header":"ReportDetails_header__3ZApV","title":"ReportDetails_title__37yZt","left":"ReportDetails_left__2Qrzw"};